import { useEffect, useState } from "react";
import api from "../lib/api";
import { bacaDataAwal } from "../lib/dataAwal";
import CustomerNav from "../components/CustomerNav";
import { useSettings } from "../context/SettingsContext";
import { AnnouncementBar } from "../components/home/AnnouncementBar";
import { HeroCarousel } from "../components/home/HeroCarousel";
import { HeroJudul } from "../components/home/HeroJudul";
import { HeroTempat } from "../components/home/HeroTempat";
import { AdvantageStrip } from "../components/home/AdvantageStrip";
import { BestSellers } from "../components/home/BestSellers";
import { PromoBanner } from "../components/home/PromoBanner";
import { Testimonials } from "../components/home/Testimonials";
import { SmallBanners } from "../components/home/SmallBanners";
import { SiteFooter } from "../components/home/SiteFooter";
import { BestSellersSkeleton, TestimonialsSkeleton } from "../components/Skeletons";
import "../styles/home-v5.css";
import { useHp } from "../hp/useHp";
import BerandaHp from "../hp/BerandaHp";

const KUNCI_CACHE = "hs_beranda_v1";

function bacaCache() {
  try {
    const raw = localStorage.getItem(KUNCI_CACHE);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

// Data banner utama + pengumuman yang disisipkan ke HTML awal (lihat backend/beranda_head.py).
const BOOT = bacaDataAwal("hs-beranda");   // blok data JSON #hs-beranda (PR8: bukan script yang dijalankan)

function slidesAwal() {
  const h = BOOT?.hero;
  if (!h || (!h.gambar && !h.gambar_hp)) return [];
  return [{
    gambar: h.gambar, gambar_hp: h.gambar_hp, gambar_960: h.gambar_960,
    gambar_mini: h.mini, gambar_hp_mini: h.mini_hp, alt: h.alt, href: h.href,
  }];
}

export default function Home() {
  const { settings } = useSettings();
  const hp = useHp();
  const awal = bacaCache();
  const [konten, setKonten] = useState(awal?.konten ?? null);
  const [terlaris, setTerlaris] = useState(awal?.terlaris ?? null);
  const [ulasan, setUlasan] = useState(awal?.ulasan ?? null);

  useEffect(() => {
    let batal = false;
    Promise.all([
      api.get("/api/konten-beranda").then(({ data }) => data).catch(() => null),
      api.get("/api/products/terlaris", { params: { limit: 4 } }).then(({ data }) => data).catch(() => []),
      api.get("/api/ulasan").then(({ data }) => data).catch(() => []),
    ]).then(([k, t, u]) => {
      if (batal) return;
      setKonten(k); setTerlaris(t); setUlasan(u);
      try { localStorage.setItem(KUNCI_CACHE, JSON.stringify({ konten: k, terlaris: t, ulasan: u })); } catch { /* kuota penuh */ }
    });
    return () => { batal = true; };
  }, []);

  // Sebelum data API tiba: pakai banner dari HTML awal. Blok judul pengganti hanya
  // muncul kalau sudah PASTI tidak ada banner.
  const slides = konten ? (konten.hero || []) : slidesAwal();
  const adaHero = slides.some((s) => s?.gambar || s?.gambar_hp);
  const pastiTanpaHero = konten ? !adaHero : BOOT?.ada_hero === false;
  const pengumuman = konten || (BOOT?.pengumuman ? {
    pengumuman_aktif: BOOT.pengumuman.aktif,
    pengumuman_teks: BOOT.pengumuman.teks,
    pengumuman_link: BOOT.pengumuman.link,
  } : null);

  if (hp) {
    // Desain HP (papan B1d). Tanpa banner: blok judul / tempat banner yang sama dengan tampilan komputer.
    const kepalaHero = adaHero ? null : pastiTanpaHero ? <HeroJudul tagline={settings?.tagline} /> : <HeroTempat mini={BOOT?.hero?.mini || BOOT?.hero?.mini_hp} />;
    return (
      <>
        {adaHero && <h1 className="sr-only">Grosir Kemasan Andalan Usaha Anda</h1>}
        <BerandaHp slides={slides} kepalaHero={kepalaHero} pengumuman={pengumuman} konten={konten}
          terlaris={terlaris} ulasan={ulasan} settings={settings} />
      </>
    );
  }

  return (
    <div className="hsv5 min-h-screen bg-[#F5F5F7] text-[#1D1D1F]">
      {pengumuman ? <AnnouncementBar konten={pengumuman} /> : null}
      <CustomerNav />
      {adaHero ? (
        <>
          <h1 className="sr-only">Grosir Kemasan Andalan Usaha Anda</h1>
          <HeroCarousel slides={slides} />
        </>
      ) : pastiTanpaHero ? (
        <HeroJudul tagline={settings?.tagline} />
      ) : (
        <HeroTempat mini={BOOT?.hero?.mini || BOOT?.hero?.mini_hp} />
      )}
      <AdvantageStrip />
      {terlaris === null ? <BestSellersSkeleton /> : <BestSellers products={terlaris} />}
      <PromoBanner banner={konten?.banner_tengah} />
      {ulasan === null ? <TestimonialsSkeleton /> : <Testimonials ulasan={ulasan} kecepatan={konten?.ulasan_kecepatan} />}
      <SmallBanners list={konten?.banner_kecil} />
      <SiteFooter konten={konten} settings={settings} />
    </div>
  );
}
